import { useQuery } from '@tanstack/react-query';
import { axios } from '@/src/lib/axios/axios';
import { QueryConfig } from '@/src/lib/react-query/react-query';
import { MESSAGING_API_BASE, messagingQueryKeys } from '../config';
import { UnreadCountsResponse } from '../types/backend';

const getUnreadCounts = async (): Promise<UnreadCountsResponse> => {
  return axios.get(`${MESSAGING_API_BASE}/unread-counts`);
};

type QueryFnType = typeof getUnreadCounts;

type UseUnreadCountsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useUnreadCounts = ({ config }: UseUnreadCountsOptions = {}) => {
  return useQuery({
    queryKey: [...messagingQueryKeys.unreadCounts()],
    queryFn: () => getUnreadCounts(),
    staleTime: 30000, // Cache for 30 seconds (increased from 10s to reduce duplicate calls)
    refetchOnWindowFocus: false, // Don't refetch on window focus - rely on socket events
    refetchOnMount: false, // Use cached data on mount to avoid duplicate calls
    // refetchInterval: 30000, // Refetch every 30 seconds - DISABLED: Rely on WebSocket events instead
    ...config,
  });
};
